import React from 'react';

interface SectionHeaderProps {
  title: string;
  eyebrow?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, eyebrow }) => {
  return (
    <div className="mb-10">
      <div className="flex items-center gap-4">
        <div className="w-1 h-8 rounded-full bg-accent-gradient flex-shrink-0" />
        <div>
          {eyebrow && (
            <span className="block text-xs font-medium uppercase tracking-[0.18em] text-accent mb-1">
              {eyebrow}
            </span>
          )}
          <h2 className="text-2xl md:text-3xl font-extrabold text-dark-heading tracking-tight">
            {title}
          </h2>
        </div>
      </div>
      <div className="mt-5 h-px bg-gradient-to-r from-dark-border via-dark-border/40 to-transparent" />
    </div>
  );
};

export default SectionHeader;
